<template>
  <b-row>
    <b-col md="12">
      <iq-card headerClass="bg-head-percent-breakdown">
        <template v-slot:headerTitle>
          <h4 class="card-title text-white"
            ><strong>PERCENTAGE BREAKDOWN</strong></h4
          >
        </template>
        <template v-slot:body>
          <div style="min-height: 350px">
            <div class="d-flex justify-content-between mb-3">
              <div class="">
                <h5 class="text-primary"
                  ><strong>{{ chartSeries[chartIdx].title }}</strong></h5
                >
              </div>
              <div class="d-flex btn-group">
                <b-button
                  :variant="chartIdx == 0 ? 'outline-primary' : 'primary'"
                  size="sm"
                  class="mr-2"
                  :disabled="chartIdx == 0"
                  @click="prev()"
                >
                  <i class="fas fa-chevron-left"></i>
                </b-button>
                <b-button
                  :variant="
                    chartIdx + 1 == chartSeries.length
                      ? 'outline-primary'
                      : 'primary'
                  "
                  size="sm"
                  :disabled="chartIdx + 1 == chartSeries.length"
                  @click="next()"
                >
                  <i class="fas fa-chevron-right"></i>
                </b-button>
              </div>
            </div>
            <div v-for="(chart, index) in chartSeries" :key="index">
              <template v-if="index == chartIdx">
                <PercentageBreakdownChart
                  :series="chart.series"
                  :element="`${index}`"
                />
              </template>
            </div>
          </div>
        </template>
      </iq-card>
    </b-col>
  </b-row>
</template>
<script>
import PercentageBreakdownChart from './Chart/PercentageBreakdownChart.vue'

export default {
  components: {
    PercentageBreakdownChart,
  },
  data() {
    return {
      chartIdx: 0,
      chartSeries: [
        {
          title: 'Tugboat & Barge',
          series: [
            {
              name: 'Percentage Breakdown',
              type: 'line',
              data: [40, 80, 37, 36, 44, 45, 50, 58, 90, 60, 50, 70],
            },
          ],
        },
        {
          title: 'Pusher Tugboat & Pusher Barge',
          series: [
            {
              name: 'Percentage Breakdown',
              type: 'line',
              data: [60, 90, 80, 90, 60, 69, 90, 79, 60, 70, 80, 90],
            },
          ],
        },
        {
          title: 'Floating Crane & Oil Barge',
          series: [
            {
              name: 'Percentage Breakdown',
              type: 'line',
              data: [20, 29, 37, 60, 90, 80, 90, 60, 69, 90, 50, 70],
            },
          ],
        },
      ],
    }
  },
  methods: {
    next() {
      this.chartIdx = this.chartIdx + 1
    },
    prev() {
      this.chartIdx = this.chartIdx - 1
    },
  },
}
</script>
<style>
.bg-head-percent-breakdown {
  background: #334697;
}
</style>
